export default __webpack_public_path__ + "static/media/search.9fd6f265.svg";